import { render, staticRenderFns } from "./FooterForm.vue?vue&type=template&id=665bddc4&"
import script from "./FooterForm.vue?vue&type=script&lang=js&"
export * from "./FooterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports